import { assertNever } from '@varos/util-typescript';
import { ChatControllerBaseConfig } from '../../../base';
import { CallRequestDetailController } from './callRequestDetailInterface';
import {
    CallRequestDetailControllerProps,
    CallRequestDetailViewProps,
} from './callRequestDetailProps';
import { FiPhone, FiPhoneOff } from 'react-icons/fi';

export function createCallRequestDetailController(
    config: ChatControllerBaseConfig
): CallRequestDetailController {
    return {
        useProps(context, data, props): CallRequestDetailViewProps {
            // Create definition object from integration definition
            const definition = data.definition?.display_name
                ? { display_name: data.definition.display_name }
                : data.integration?.definition_id
                  ? { display_name: data.integration.definition_id }
                  : undefined;

            // Create participants array with dynamic speaking indicators
            const assistantName = definition?.display_name || 'Assistant';

            // TODO: Get speaking state from actual call implementation
            // For now, we'll determine speaking based on recent transcript activity
            const recentTranscript = data.context?.context?.transcript?.slice(-3) ?? [];
            const userSpeaking = recentTranscript.some((entry) => entry.role === 'user');
            const systemSpeaking = recentTranscript.some(
                (entry) => entry.role === 'assistant'
            );

            const participants = [
                {
                    kind: 'assistant' as const,
                    label: assistantName,
                    speaking: systemSpeaking,
                    avatar: assistantName.substring(0, 2).toUpperCase(),
                },
                {
                    kind: 'user' as const,
                    label: 'You',
                    speaking: userSpeaking,
                    avatar: 'YO',
                },
            ];

            return {
                status: {
                    label: 'Connected',
                    description: 'You are connected to the call',
                    kind: 'connected',
                    Icon: FiPhone,
                    colorScheme: 'green',
                },
                participants,
                definition,
                end: {
                    button: {
                        onClick: props.onEndRequested,
                    },
                },
            };
        },
    };
}
